export default {
      id: "carret-usage",
      viewBox: "0 0 306 306",
      url: "../../assets/" + "sprite.svg#carret-usage",
      toString: function () {
        return this.url;
      }
    }